import ReportWrapper from '../ReportWrapper'
import React from 'react'
import RongdataFailureComplyCasesOverview from './RongdataFailureComplyCasesOverview'
import FailureComplyCase from './FailureComplyCase'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import { Stack, Text } from '@mantine/core'
import ReportSectionHeading from '../ReportSectionHeading'
import { useTheme } from '../../../components/ThemeProvider'

interface FailureComplyCasesProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function RongdataFailureComplyCases({ data, title, sectionIndex }: FailureComplyCasesProps) {
  const theme = useTheme()
  const cases = data?.dishonest_case_info ?? []
  const caseCount = cases.length

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <RongdataFailureComplyCasesOverview data={data} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          失信被执行案件
        </Text>
        <Stack gap="sm" className="mt-3">
          <ExpandableListWrapper isEmpty={caseCount === 0}>
            {cases.map((item: any, index: number) => (
              <FailureComplyCase number={index + 1} key={index} item={item} />
            ))}
          </ExpandableListWrapper>
        </Stack>
      </div>
    </ReportWrapper>
  )
}
